import React from 'react';
import { ContentProps, FootNoteProps } from '../../models/TopLevelTemplateComponentProps';
import sanitizeHTML from '../../services/sanitizeHTML';
import LinkifiedHtml from '../LinkifiedHtml';
import { StyledTypography } from '../styles/styles';
import { NestedContent, StandardHeaderContentValue } from './standardHeaderContentUtils';

interface StandardHeaderContentListProps {
  content: StandardHeaderContentValue;
  footnotes?: FootNoteProps[];
}

function StandardHeaderContentItem({
  item,
  footnotes,
}: {
  item: ContentProps;
  footnotes?: FootNoteProps[];
}) {
  return <LinkifiedHtml as={StyledTypography} html={sanitizeHTML(item.content, { footnotes })} />;
}

export default function StandardHeaderContentList({
  content,
  footnotes,
}: StandardHeaderContentListProps) {
  if (!Array.isArray(content)) {
    return <StandardHeaderContentItem item={content} footnotes={footnotes} />;
  }

  return (
    <ul style={{ marginTop: 0, marginBottom: 0 }}>
      {content.map((item) => {
        if (Array.isArray(item)) {
          const [parent, children] = item as NestedContent;
          return (
            <li key={parent.id}>
              <StandardHeaderContentItem item={parent} footnotes={footnotes} />
              <ul>
                {children.map((child) => (
                  <li key={child.id}>
                    <StandardHeaderContentItem item={child} footnotes={footnotes} />
                  </li>
                ))}
              </ul>
            </li>
          );
        }
        const flatItem = item as ContentProps;
        return (
          <li key={flatItem.id}>
            <StandardHeaderContentItem item={flatItem} footnotes={footnotes} />
          </li>
        );
      })}
    </ul>
  );
}
